export default "__VITE_ASSET__DDGOyn_6__"